export const TERMS_AND_CONDITIONS_CHARACTER_LIMIT = 1024
